<div>
  <div class="attentionHeader" style="height: 50px; font-size: 20px; text-align: center; padding: 10px">
    {{ rGuestBookMessages.profile.profileMessage9 }}
  </div>
  <div>
    <p style="padding: 20px; font-size: 20px">
      {{ rGuestBookMessages.profile.profileMessage10 }}
      {{ username | capitalize }}{{ rGuestBookMessages.profile.profileMessage11 }}{{ timeout
      }}{{ rGuestBookMessages.profile.profileMessage13 }}
    </p>
    <div style="text-align: center; margin-bottom: 10px">
      <button mat-raised-button (click)="proceedtoWork()" color="primary">{{ rGuestBookMessages.commonConstants.userIdleButton1 }}</button>
      <button mat-raised-button class="ml-1" (click)="logout()" color="warn">
        {{ rGuestBookMessages.commonConstants.userIdleButton2 }}
      </button>
    </div>
  </div>
</div>
